// Copyright (c) 2018 Comsearch, Inc., All rights reserved

import { castToFloat } from 'helpers/reduxFormFunctions'

import formatAdministration from './formatAdministration'
import formatAntennas from './formatAntennas'
import formatFrequencyInfo from './formatFrequencyInfo'
import formatLosses from './formatLosses'
import formatPassiveRepeaters from './formatPassiveRepeaters'
import formatRadio from './formatRadio'
import formatRegulatory from './formatRegulatory'
import formatSite from './formatSite'
import formatSegmentEndAux from './formatSegmentEndAux'

const formatPathDetailsData = formData => {
  const {
    administration,
    antennas,
    band,
    losses,
    frequencyPlans,
    jobCode,
    passiveRepeaters,
    pathId,
    pathName,
    pathStatusId,
    pplFlippedFlag,
    pplPathId,
    pplRcn,
    pplSite1Name,
    pplSite2Name,
    radios,
    rcnNumber,
    regulatory,
    segmentIds,
    sites,
  } = formData

  // begin extracting data for the segments array.
  // first set up the two path ends:
  // format their data
  // assign their antennas
  const s1 = {
    ...formatFrequencyInfo(frequencyPlans[0]),
    ...formatSite(sites[0]),
    ...formatRegulatory(regulatory[0]),
    ...formatAdministration(administration[0]),
    ...formatRadio(radios[0]),
    ...formatLosses(losses[0]),
    segmentEndAux: formatSegmentEndAux(sites[0]),
    antennas: formatAntennas(antennas[0]),
  }

  const s2 = {
    ...formatFrequencyInfo(frequencyPlans[1]),
    ...formatSite(sites[1]),
    ...formatRegulatory(regulatory[1]),
    ...formatAdministration(administration[1]),
    ...formatRadio(radios[1]),
    ...formatLosses(losses[1]),
    segmentEndAux: formatSegmentEndAux(sites[1]),
    antennas: formatAntennas(antennas[1]),
  }

  // the path will start with the Site 1 data
  const segments = [{
    segmentEnds: [s1],
  }]

  // if there are any passive repeaters, scrub their data and add to the segments array.
  formatPassiveRepeaters(passiveRepeaters, segments)

  // add the path end ("site 2") to the segments array.
  segments[segments.length - 1].segmentEnds[1] = s2

  // we then need to assign the segmentId based on the original segment ids from the API
  // if segments is longer than segmentIds, then we're definging a new segment for the API
  // which doesn't yet have an id.
  // if segments is shorter than segmentIds, then we're removing segment(s) from the path
  // and the API knows how to handle this scenario
  segments.forEach((segment, i) => {
    segment.segmentId = segmentIds[i] || null

    // make sure to track segmentNumber and segmentEndNumber here so that backend can trust the order we're giving and
    // not have to magically infer a bunch of stuff.
    segment.segmentNumber = i + 1
    segment.segmentEnds.forEach((segmentEnd, ii) => {
      segmentEnd.segmentEndNumber = ii + 1
    })
  })

  return {
    bandId: castToFloat(band),
    jobCode,
    pathStatusId,
    pathId,
    pathName: pathName.trim() || null,
    pplFlippedFlag,
    pplPathId,
    pplRcn,
    pplSite1Name,
    pplSite2Name,
    rcnNumber,
    segments,
  }
}

export default formatPathDetailsData
